import { createSlice } from '@reduxjs/toolkit';

const initialState={
    customisations:null
}
export const customisationSlice = createSlice({
  name: 'customisations',
  initialState,
  reducers: {

    
      
      setCustomisation: (state, action) => {
        state.customisations = action.payload;
        
      },
      setLogoutCustomisation: (state,action)=>{
      state.customisations=null
    }
  },
});

export const {  setCustomisation,setLogoutCustomisation } = customisationSlice.actions;

export default customisationSlice.reducer;
